/*
  <kg-review-form>: schickt eine Bewertung an den Bewertungsdienst. Der Aufruf geht ohne
  Zugangsdaten an dieselbe oeffentliche Stelle, die auch das Original-Formular nutzt.
  Veroeffentlicht wird dort erst nach Pruefung, hier erscheint nur die Bestaetigung.
*/

const ZIEL = 'https://judge.me/api/v1/reviews';

class KgReviewForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('[data-review-form]');
    this.meldung = this.querySelector('[data-review-message]');
    if (!this.form) return;
    this.form.addEventListener('submit', (event) => this.senden(event));
  }

  async senden(event) {
    event.preventDefault();
    const daten = new FormData(this.form);

    /* Koederfeld: nur Roboter fuellen es aus, dann wird Erfolg gemeldet, ohne zu senden */
    if (daten.get('website')) {
      this.zeigen(this.dataset.success, true);
      this.form.reset();
      return;
    }

    const knopf = this.form.querySelector('[type="submit"]');
    knopf.disabled = true;
    knopf.setAttribute('aria-busy', 'true');

    const felder = new URLSearchParams({
      shop_domain: this.dataset.shop,
      platform: 'shopify',
      id: this.dataset.product,
      name: daten.get('name') || '',
      email: daten.get('email') || '',
      rating: daten.get('rating') || '5',
      title: daten.get('title') || '',
      body: daten.get('body') || '',
    });

    try {
      const antwort = await fetch(ZIEL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: felder,
      });
      if (!antwort.ok) throw new Error(String(antwort.status));
      this.zeigen(this.dataset.success, true);
      this.form.reset();
    } catch {
      this.zeigen(this.dataset.error, false);
    } finally {
      knopf.disabled = false;
      knopf.removeAttribute('aria-busy');
    }
  }

  zeigen(text, erfolg) {
    if (!this.meldung) return;
    this.meldung.textContent = text || '';
    this.meldung.hidden = false;
    this.meldung.classList.toggle('reviews-form__message--ok', Boolean(erfolg));
  }
}

customElements.define('kg-review-form', KgReviewForm);
